import React, {useState, lazy, Suspense} from 'react';
import { useTranslation } from 'react-i18next';
import {CircularProgress, Tooltip} from "@mui/material";
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { ReactComponent as Logo } from './img/combined.svg';
import { ReactComponent as TCP } from './img/tcp.svg';
import { ReactComponent as ArcLogo } from './img/arc-logo.svg';
import {payout} from "../utils/payoutFunctions";
import {numberWithCommas} from "../utils/formatFunctions";
import CloseButton from "./closeButton";

// Loaded when the report is first opened: the table library is not needed to display the map
const ReportFloodTableExport = lazy(() => import("./reportFloodTableExport"));

const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 0.9
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: '90vw',
        height: '80vh',
        overflow:'scroll',
        // phones: full screen, opaque
        [theme.breakpoints.down('xs')]: {
            boxSizing: 'border-box',
            width: '100vw',
            height: '100dvh',
            padding: theme.spacing(2, 1.5, 3),
            border: 'none',
        },
    },
}));
export default function ReportFloodPopUp(props) {

    const { t } = useTranslation();

    const classes = useStyles();

    const [open, setOpen] = React.useState(false);
    const [mapImage, setMapImage] = useState(null);

    const {selectedFloodData, map} = props;

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    function mapToURL(map) {
        map.once('render', () => {
            setMapImage(map.getCanvas().toDataURL('image/png'))
        })
    }

    mapToURL(map)

    return (
        <div className={'button-report'}>
            <Tooltip placement={'top'} title={t('buttons.report.helper')}>
                <Button variant="contained" color="secondary" onClick={handleOpen}>
                    {t('buttons.report.title')}
                </Button>
            </Tooltip>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal + ' report-modal'}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 0,
                }}
            >
                <Fade in={open}>
                    <div className={classes.paper + ' report-paper'}>
                        <CloseButton handleClose={handleClose} />
                        <ArcLogo className={'report-logo'} />
                        {mapImage &&
                            <div className={'map-report'}>
                                <img src={mapImage} style={{ width: "80%", margin: "30px 0" }}/>
                            </div>
                        }
                        {/*<EnhancedTable />*/}
                        <Tooltip placement={'top'} title={t('report.pop_losses.helper')}>
                            <div className="long-title"><h3>{t('report.pop_losses.title')}</h3></div>
                        </Tooltip>
{/*                        Payout:
                        {currentLosses.map(x => (
                            <div>{x.adm0_name} : ${numberWithCommas(payout(9890026,0.0037,2704142526,17562830,x.loss))}</div>
                            ))}*/}
                        {/*<ReportTable currentLosses={currentLosses} />*/}
                        <Suspense fallback={<CircularProgress />}>
                        <ReportFloodTableExport selectedFloodData={selectedFloodData} />
                        </Suspense>
                    </div>
                </Fade>
            </Modal>
        </div>
    );
}
